import { render, staticRenderFns } from "./RegionalMapWithAvatars.vue?vue&type=template&id=4b9d1b3e"
import script from "./RegionalMapWithAvatars.vue?vue&type=script&lang=js"
export * from "./RegionalMapWithAvatars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IconsNode: require('/opt/build/repo/components/Icons/Node.vue').default,ElementsSlider: require('/opt/build/repo/components/Elements/Slider.vue').default})
